import { render, staticRenderFns } from "./DepartmentHome.vue?vue&type=template&id=0896f980&"
import script from "./DepartmentHome.vue?vue&type=script&lang=js&"
export * from "./DepartmentHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports